import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailSection } from './components/WhyFailSection';
import { BeneficiosSection } from './components/MechanismSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { GarantiaSection } from './components/GarantiaSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '987686134426392');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy-900 font-sans text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyFailSection data-id="element-3" />
      <BeneficiosSection data-id="element-4" />
      <TestimonialsSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <GarantiaSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <CTASection data-id="element-10" />
      <Footer data-id="element-11" />
      <StickyMobileCTA data-id="element-12" />
    </div>;
}